import { Text, TextStyle, Graphics } from 'pixi.js'

const style = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 36,
  fill: '#c77059',
})

class Underline extends Text {
  constructor(text) {
    super(text, style)

    this.anchor.set(0.5)

    const line = new Graphics()
    line.lineStyle(2, 0xc77059, 1)
    line.moveTo(0, 0)
    line.lineTo(this.width, 0)
    line.x = -this.width * 0.5
    line.y = this.height * 0.6
    this.addChild(line)
  }
}

export default Underline
